export const idlFactory = ({ IDL }) => {
	const ClaimCondition = IDL.Rec();
	const Result_1 = IDL.Variant({ ok: IDL.Null, err: IDL.Text });
	const AdminClaimFilter = IDL.Record({
		claimer: IDL.Opt(IDL.Principal),
		giftId: IDL.Opt(IDL.Text),
	});
	const ClaimStatus = IDL.Variant({
		Failed: IDL.Text,
		Success: IDL.Null,
		Pending: IDL.Null,
	});
	const Time = IDL.Int;
	const ClaimRecord = IDL.Record({
		id: IDL.Nat,
		status: ClaimStatus,
		claimer: IDL.Principal,
		claimTime: Time,
		transferId: IDL.Opt(IDL.Nat),
		amount: IDL.Nat,
		giftId: IDL.Text,
	});
	const AdminClaimsResponse = IDL.Record({
		claims: IDL.Vec(ClaimRecord),
		total: IDL.Nat,
		hasMore: IDL.Bool,
	});
	const Result_13 = IDL.Variant({
		ok: AdminClaimsResponse,
		err: IDL.Text,
	});
	const GiftStatus = IDL.Variant({
		Refunded: IDL.Null,
		Active: IDL.Null,
		Cancelled: IDL.Null,
		Completed: IDL.Null,
		Expired: IDL.Null,
		Pending: IDL.Null,
	});
	const AdminGiftFilter = IDL.Record({
		status: IDL.Opt(GiftStatus),
		creator: IDL.Opt(IDL.Principal),
		tokenId: IDL.Opt(IDL.Text),
		isPublic: IDL.Opt(IDL.Bool),
	});
	const TokenInfo = IDL.Record({
		tokenId: IDL.Text,
		displayToChainDecimals: IDL.Nat8,
		tokenName: IDL.Text,
		displayUnitName: IDL.Text,
	});
	const GiftType = IDL.Variant({ Fixed: IDL.Null, Random: IDL.Null });
	const PasswordCondition = IDL.Record({
		salt: IDL.Vec(IDL.Nat8),
		passwordHash: IDL.Vec(IDL.Nat8),
	});
	const HoldTokenCondition = IDL.Record({
		decimals: IDL.Nat8,
		tokenId: IDL.Text,
		minAmount: IDL.Nat,
	});
	const LotteryPrize = IDL.Record({
		name: IDL.Text,
		count: IDL.Nat,
		amount: IDL.Nat,
	});
	const LotteryCondition = IDL.Record({ prizes: IDL.Vec(LotteryPrize) });
	ClaimCondition.fill(
		IDL.Variant({
			Login: IDL.Null,
			Password: PasswordCondition,
			None: IDL.Null,
			HoldToken: HoldTokenCondition,
			Composite: IDL.Vec(ClaimCondition),
			Whitelist: IDL.Vec(IDL.Principal),
			Lottery: LotteryCondition,
		}),
	);
	const GiftPacket = IDL.Record({
		id: IDL.Text,
		refundAmount: IDL.Opt(IDL.Nat),
		status: GiftStatus,
		claimFeeCreatorBalance: IDL.Nat,
		feeAmount: IDL.Nat,
		refundTransferId: IDL.Opt(IDL.Nat),
		creator: IDL.Principal,
		remainingAmount: IDL.Nat,
		feeTokenInfo: TokenInfo,
		claimFeePlatformMin: IDL.Nat,
		activateTime: IDL.Opt(Time),
		claimFeeCreatorClaimed: IDL.Nat,
		memo: IDL.Opt(IDL.Text),
		claimFeePerClaim: IDL.Opt(IDL.Nat),
		totalCount: IDL.Nat,
		createTime: Time,
		refundTime: IDL.Opt(Time),
		feeOperationId: IDL.Opt(IDL.Nat),
		totalAmount: IDL.Nat,
		coverId: IDL.Opt(IDL.Text),
		tokenInfo: TokenInfo,
		isPublic: IDL.Bool,
		claimFeePlatformTotal: IDL.Nat,
		expireTime: Time,
		claimedCount: IDL.Nat,
		giftType: GiftType,
		depositOperationId: IDL.Opt(IDL.Nat),
		feeTransferCount: IDL.Nat,
		viralRewardPoolDeposited: IDL.Nat,
		condition: ClaimCondition,
	});
	const AdminGiftsResponse = IDL.Record({
		total: IDL.Nat,
		hasMore: IDL.Bool,
		gifts: IDL.Vec(GiftPacket),
	});
	const Result_12 = IDL.Variant({
		ok: AdminGiftsResponse,
		err: IDL.Text,
	});
	const AdminWithdrawResponse = IDL.Record({
		chainAmount: IDL.Nat,
		transferId: IDL.Nat,
		displayAmount: IDL.Nat,
	});
	const Result_11 = IDL.Variant({
		ok: AdminWithdrawResponse,
		err: IDL.Text,
	});
	const ClaimFeeRewardsResponse = IDL.Record({
		transferId: IDL.Nat,
		tokenName: IDL.Text,
		amountRaw: IDL.Nat,
		amount: IDL.Nat,
	});
	const Result_10 = IDL.Variant({
		ok: ClaimFeeRewardsResponse,
		err: IDL.Text,
	});
	const ClaimResponse = IDL.Record({
		prizeIndex: IDL.Opt(IDL.Nat),
		memo: IDL.Opt(IDL.Text),
		transferId: IDL.Nat,
		tokenName: IDL.Text,
		amountRaw: IDL.Nat,
		amount: IDL.Nat,
		prizeName: IDL.Opt(IDL.Text),
	});
	const Result_9 = IDL.Variant({ ok: ClaimResponse, err: IDL.Text });
	const ClaimViralRewardsResponse = IDL.Record({
		rewardAmount: IDL.Nat,
		rewardAmountRaw: IDL.Nat,
		transferId: IDL.Nat,
		tokenName: IDL.Text,
	});
	const Result_8 = IDL.Variant({
		ok: ClaimViralRewardsResponse,
		err: IDL.Text,
	});
	const ViralParams = IDL.Record({
		maxInvitesPerUser: IDL.Nat,
		inviterRewardRate: IDL.Nat,
		totalRewardPool: IDL.Nat,
	});
	const CreateGiftParams = IDL.Record({
		tokenId: IDL.Text,
		memo: IDL.Opt(IDL.Text),
		claimFeePerClaim: IDL.Opt(IDL.Nat),
		totalCount: IDL.Nat,
		expireHours: IDL.Opt(IDL.Nat),
		viralParams: IDL.Opt(ViralParams),
		totalAmount: IDL.Nat,
		coverId: IDL.Opt(IDL.Text),
		isPublic: IDL.Opt(IDL.Bool),
		giftType: GiftType,
		condition: ClaimCondition,
	});
	const CreateGiftResponse = IDL.Record({
		feeAmount: IDL.Nat,
		requiredDeposit: IDL.Nat,
		claimFeePerClaim: IDL.Opt(IDL.Nat),
		feeTokenId: IDL.Text,
		viralRewardPool: IDL.Nat,
		giftId: IDL.Text,
		canisterId: IDL.Principal,
	});
	const Result_7 = IDL.Variant({ ok: CreateGiftResponse, err: IDL.Text });
	const Result_6 = IDL.Variant({ ok: IDL.Text, err: IDL.Text });
	const CanisterBalanceInfo = IDL.Record({
		tokenId: IDL.Text,
		chainAmount: IDL.Nat,
		displayToChainDecimals: IDL.Nat8,
		displayAmount: IDL.Nat,
	});
	const Result_5 = IDL.Variant({
		ok: CanisterBalanceInfo,
		err: IDL.Text,
	});
	const ClaimFeeStats = IDL.Record({
		creatorFeeAvailable: IDL.Nat,
		claimFeePerClaim: IDL.Opt(IDL.Nat),
		creatorFeeTotal: IDL.Nat,
		claimFeeTokenInfo: IDL.Opt(TokenInfo),
		giftId: IDL.Text,
		creatorFeeClaimed: IDL.Nat,
		platformFeeTotal: IDL.Nat,
	});
	const Result_4 = IDL.Variant({ ok: ClaimFeeStats, err: IDL.Text });
	const FeeTokenConfig = IDL.Record({
		tokenId: IDL.Text,
		displayToChainDecimals: IDL.Nat8,
		enabled: IDL.Bool,
		tokenName: IDL.Text,
		feePerTransfer: IDL.Nat,
		displayUnitName: IDL.Text,
	});
	const ViralGiftConfig = IDL.Record({
		maxInvitesPerUser: IDL.Nat,
		usedRewardPool: IDL.Nat,
		inviterRewardRate: IDL.Nat,
		totalRewardPool: IDL.Nat,
		enabled: IDL.Bool,
	});
	const ClaimRecordWithPrize = IDL.Record({
		id: IDL.Nat,
		status: ClaimStatus,
		prizeIndex: IDL.Opt(IDL.Nat),
		claimer: IDL.Principal,
		claimTime: Time,
		transferId: IDL.Opt(IDL.Nat),
		amount: IDL.Nat,
		giftId: IDL.Text,
		prizeName: IDL.Opt(IDL.Text),
	});
	const GiftInfo = IDL.Record({
		gift: GiftPacket,
		viralConfig: IDL.Opt(ViralGiftConfig),
		claimRecords: IDL.Vec(ClaimRecordWithPrize),
		displayAmount: IDL.Record({ total: IDL.Nat, remaining: IDL.Nat }),
		canClaim: IDL.Bool,
	});
	const MyClaimRecordEnriched = IDL.Record({
		id: IDL.Nat,
		status: ClaimStatus,
		prizeIndex: IDL.Opt(IDL.Nat),
		claimer: IDL.Principal,
		sender: IDL.Principal,
		claimTime: Time,
		transferId: IDL.Opt(IDL.Nat),
		coverId: IDL.Opt(IDL.Text),
		tokenInfo: TokenInfo,
		amount: IDL.Nat,
		giftMemo: IDL.Opt(IDL.Text),
		giftId: IDL.Text,
		prizeName: IDL.Opt(IDL.Text),
	});
	const MyInviteRewardGiftSummary = IDL.Record({
		pendingReward: IDL.Nat,
		creator: IDL.Principal,
		totalRewardEarned: IDL.Nat,
		memo: IDL.Opt(IDL.Text),
		createTime: Time,
		totalRewardEarnedRaw: IDL.Nat,
		coverId: IDL.Opt(IDL.Text),
		pendingRewardRaw: IDL.Nat,
		tokenInfo: TokenInfo,
		canClaim: IDL.Bool,
		giftStatus: GiftStatus,
		expireTime: Time,
		giftId: IDL.Text,
		totalInvites: IDL.Nat,
		successfulInvites: IDL.Nat,
	});
	const MyInviteRewardGiftsResponse = IDL.Record({
		total: IDL.Nat,
		hasMore: IDL.Bool,
		gifts: IDL.Vec(MyInviteRewardGiftSummary),
	});
	const UserInviteStats = IDL.Record({
		pendingReward: IDL.Nat,
		totalRewardEarned: IDL.Nat,
		user: IDL.Principal,
		totalInvites: IDL.Nat,
		successfulInvites: IDL.Nat,
	});
	const PublicGiftFilter = IDL.Record({
		hasClaimFee: IDL.Opt(IDL.Bool),
		tokenId: IDL.Opt(IDL.Text),
		hasPassword: IDL.Opt(IDL.Bool),
		requiresLogin: IDL.Opt(IDL.Bool),
		hasHoldToken: IDL.Opt(IDL.Bool),
		creatorId: IDL.Opt(IDL.Principal),
		hasLottery: IDL.Opt(IDL.Bool),
		hasWhitelist: IDL.Opt(IDL.Bool),
		hasViral: IDL.Opt(IDL.Bool),
		giftType: IDL.Opt(GiftType),
		allowsAnonymous: IDL.Opt(IDL.Bool),
	});
	const SortField = IDL.Variant({
		TotalCount: IDL.Null,
		CreateTime: IDL.Null,
		TotalAmount: IDL.Null,
		RemainingCount: IDL.Null,
		ExpireTime: IDL.Null,
	});
	const SortOrder = IDL.Variant({ Asc: IDL.Null, Desc: IDL.Null });
	const SortConfig = IDL.Record({ field: SortField, order: SortOrder });
	const PublicGiftSummary = IDL.Record({
		id: IDL.Text,
		remainingAmount: IDL.Nat,
		memo: IDL.Opt(IDL.Text),
		totalCount: IDL.Nat,
		createTime: Time,
		viralConfig: IDL.Opt(ViralGiftConfig),
		totalAmount: IDL.Nat,
		coverId: IDL.Opt(IDL.Text),
		tokenInfo: TokenInfo,
		expireTime: Time,
		giftType: GiftType,
		remainingCount: IDL.Nat,
		condition: ClaimCondition,
	});
	const PublicGiftsResponse = IDL.Record({
		total: IDL.Nat,
		hasMore: IDL.Bool,
		gifts: IDL.Vec(PublicGiftSummary),
	});
	const SystemStatus = IDL.Variant({
		Stopped: IDL.Null,
		Paused: IDL.Null,
		Active: IDL.Null,
	});
	const SystemControls = IDL.Record({
		createEnabled: IDL.Bool,
		refundEnabled: IDL.Bool,
		claimEnabled: IDL.Bool,
		systemStatus: SystemStatus,
	});
	const SystemStats = IDL.Record({
		totalGiftsCreated: IDL.Nat,
		totalFeesCollected: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat)),
		activeGiftsCount: IDL.Nat,
		totalGiftsClaimed: IDL.Nat,
		totalAmountDistributed: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat)),
	});
	const TokenConfig = IDL.Record({
		tokenId: IDL.Text,
		minAmount: IDL.Nat,
		displayToChainDecimals: IDL.Nat8,
		enabled: IDL.Bool,
		tokenName: IDL.Text,
		displayUnitName: IDL.Text,
	});
	const ViralStats = IDL.Record({
		topInviters: IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat)),
		totalRewardPaid: IDL.Nat,
		remainingRewardPool: IDL.Nat,
		giftId: IDL.Text,
		totalInvites: IDL.Nat,
	});
	const PreClaimGiftResponse = IDL.Record({
		claimFeePerClaim: IDL.Opt(IDL.Nat),
		claimFeeTokenInfo: IDL.Opt(TokenInfo),
		giftId: IDL.Text,
	});
	const Result_3 = IDL.Variant({
		ok: PreClaimGiftResponse,
		err: IDL.Text,
	});
	const Direction = IDL.Variant({
		Backward: IDL.Null,
		Forward: IDL.Null,
	});
	const CursorType = IDL.Variant({ Nat: IDL.Nat, Text: IDL.Text });
	const PaginatedResult_1 = IDL.Record({
		hasMore: IDL.Bool,
		prevCursor: IDL.Opt(CursorType),
		data: IDL.Vec(MyClaimRecordEnriched),
		totalCount: IDL.Opt(IDL.Nat),
		nextCursor: IDL.Opt(CursorType),
	});
	const OperationType = IDL.Variant({
		ClaimGift: IDL.Null,
		ConfirmDeposit: IDL.Null,
		ClaimFeeRewards: IDL.Null,
		AdminAction: IDL.Null,
		CreateGift: IDL.Null,
		RefundGift: IDL.Null,
		CancelGift: IDL.Null,
		SetTokenConfig: IDL.Null,
		Other: IDL.Null,
		SetFeeConfig: IDL.Null,
	});
	const OperationQueryScope = IDL.Variant({
		ByType: OperationType,
		ByUser: IDL.Principal,
		Global: IDL.Null,
	});
	const OperationStatus = IDL.Variant({
		Failed: IDL.Text,
		Success: IDL.Null,
		Pending: IDL.Null,
	});
	const OperationDetails = IDL.Variant({
		ClaimGift: IDL.Record({
			transferId: IDL.Nat,
			amount: IDL.Nat,
			giftId: IDL.Text,
		}),
		ConfirmDeposit: IDL.Record({
			operationId: IDL.Nat,
			giftId: IDL.Text,
		}),
		ClaimFeeRewards: IDL.Record({
			transferId: IDL.Nat,
			amount: IDL.Nat,
			giftId: IDL.Text,
		}),
		AdminAction: IDL.Record({
			action: IDL.Text,
			target: IDL.Opt(IDL.Principal),
			params: IDL.Text,
		}),
		CreateGift: IDL.Record({
			tokenId: IDL.Text,
			count: IDL.Nat,
			amount: IDL.Nat,
			giftId: IDL.Text,
		}),
		RefundGift: IDL.Record({
			transferId: IDL.Nat,
			amount: IDL.Nat,
			giftId: IDL.Text,
		}),
		CancelGift: IDL.Record({ giftId: IDL.Text }),
		SetTokenConfig: IDL.Record({
			tokenId: IDL.Text,
			enabled: IDL.Bool,
		}),
		Other: IDL.Record({ message: IDL.Text }),
		CreateGiftV2: IDL.Record({
			tokenId: IDL.Text,
			count: IDL.Nat,
			coverId: IDL.Opt(IDL.Text),
			amount: IDL.Nat,
			giftId: IDL.Text,
		}),
		SetFeeConfig: IDL.Record({
			tokenId: IDL.Text,
			feePerTransfer: IDL.Nat,
		}),
	});
	const OperationRecord = IDL.Record({
		id: IDL.Nat,
		status: OperationStatus,
		operator: IDL.Principal,
		memo: IDL.Opt(IDL.Text),
		operationType: OperationType,
		relatedIds: IDL.Vec(IDL.Text),
		timestamp: Time,
		details: OperationDetails,
	});
	const PaginatedResult = IDL.Record({
		hasMore: IDL.Bool,
		prevCursor: IDL.Opt(CursorType),
		data: IDL.Vec(OperationRecord),
		totalCount: IDL.Opt(IDL.Nat),
		nextCursor: IDL.Opt(CursorType),
	});
	const RefundResponse = IDL.Record({
		refundAmount: IDL.Nat,
		transferId: IDL.Nat,
	});
	const Result_2 = IDL.Variant({ ok: RefundResponse, err: IDL.Text });
	const Result = IDL.Variant({ ok: IDL.Nat, err: IDL.Text });
	return IDL.Service({
		addAdmin: IDL.Func([IDL.Principal], [Result_1], []),
		adminQueryClaims: IDL.Func(
			[AdminClaimFilter, IDL.Nat, IDL.Nat],
			[Result_13],
			["query"],
		),
		adminQueryGifts: IDL.Func(
			[AdminGiftFilter, IDL.Nat, IDL.Nat],
			[Result_12],
			["query"],
		),
		adminWithdrawToken: IDL.Func(
			[IDL.Text, IDL.Principal, IDL.Nat, IDL.Nat8],
			[Result_11],
			[],
		),
		cancelGift: IDL.Func([IDL.Text], [Result_1], []),
		claimFeeRewards: IDL.Func([IDL.Text], [Result_10], []),
		claimGift: IDL.Func(
			[
				IDL.Text,
				IDL.Opt(IDL.Principal),
				IDL.Opt(IDL.Text),
				IDL.Opt(IDL.Vec(IDL.Nat8)),
				IDL.Opt(IDL.Nat),
			],
			[Result_9],
			[],
		),
		claimViralRewards: IDL.Func([IDL.Text], [Result_8], []),
		confirmDeposit: IDL.Func(
			[IDL.Text, IDL.Nat, IDL.Opt(IDL.Nat)],
			[Result_1],
			[],
		),
		createGift: IDL.Func([CreateGiftParams], [Result_7], []),
		generateInviteCode: IDL.Func([IDL.Text], [Result_6], []),
		getCanisterId: IDL.Func([], [IDL.Principal], ["query"]),
		getCanisterTokenBalance: IDL.Func([IDL.Text, IDL.Nat8], [Result_5], []),
		getClaimFeeStats: IDL.Func([IDL.Text], [Result_4], ["query"]),
		getFeeTokenConfigs: IDL.Func(
			[],
			[IDL.Vec(IDL.Tuple(IDL.Text, FeeTokenConfig))],
			["query"],
		),
		getGiftInfo: IDL.Func(
			[IDL.Text, IDL.Opt(IDL.Principal)],
			[IDL.Opt(GiftInfo)],
			["query"],
		),
		getMyClaimRecords: IDL.Func(
			[],
			[IDL.Vec(MyClaimRecordEnriched)],
			["query"],
		),
		getMyCreatedGifts: IDL.Func([], [IDL.Vec(GiftPacket)], ["query"]),
		getMyInviteRewardGifts: IDL.Func(
			[IDL.Nat, IDL.Nat],
			[MyInviteRewardGiftsResponse],
			["query"],
		),
		getMyInviteStats: IDL.Func([IDL.Text], [UserInviteStats], ["query"]),
		getPlatformFeeBalance: IDL.Func([IDL.Text], [IDL.Nat], ["query"]),
		getPublicActiveGifts: IDL.Func(
			[IDL.Opt(PublicGiftFilter), IDL.Opt(SortConfig), IDL.Nat, IDL.Nat],
			[PublicGiftsResponse],
			["query"],
		),
		getSystemControls: IDL.Func([], [SystemControls], ["query"]),
		getSystemStats: IDL.Func([], [SystemStats], ["query"]),
		getTokenConfigs: IDL.Func(
			[],
			[IDL.Vec(IDL.Tuple(IDL.Text, TokenConfig))],
			["query"],
		),
		getUserInviteStats: IDL.Func(
			[IDL.Text, IDL.Principal],
			[UserInviteStats],
			["query"],
		),
		getViralConfig: IDL.Func([IDL.Text], [IDL.Opt(ViralGiftConfig)], ["query"]),
		getViralStats: IDL.Func([IDL.Text], [ViralStats], ["query"]),
		isAdmin: IDL.Func([IDL.Principal], [IDL.Bool], ["query"]),
		preClaimGift: IDL.Func(
			[
				IDL.Text,
				IDL.Opt(IDL.Principal),
				IDL.Opt(IDL.Text),
				IDL.Opt(IDL.Vec(IDL.Nat8)),
			],
			[Result_3],
			[],
		),
		queryAllClaimRecords: IDL.Func(
			[IDL.Opt(IDL.Nat), Direction, IDL.Nat],
			[PaginatedResult_1],
			["query"],
		),
		queryOperations: IDL.Func(
			[OperationQueryScope, IDL.Opt(IDL.Nat), Direction, IDL.Nat],
			[PaginatedResult],
			["query"],
		),
		refundGift: IDL.Func([IDL.Text], [Result_2], []),
		removeAdmin: IDL.Func([IDL.Principal], [Result_1], []),
		setFeeTokenConfig: IDL.Func([FeeTokenConfig], [Result_1], []),
		setSystemStatus: IDL.Func([SystemStatus], [Result_1], []),
		setTokenConfig: IDL.Func([TokenConfig], [Result_1], []),
		withdrawPlatformFee: IDL.Func(
			[IDL.Text, IDL.Nat, IDL.Principal],
			[Result],
			[],
		),
	});
};
export const init = ({ IDL }) => {
	return [];
};
